/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'underscore';
import { renderChildern, types, Types } from '../util';
import { DataModel } from './dataModel';

const emptyErrorMessages = [];

class FilterOptionsGroupItem extends React.PureComponent {
  constructor(props) {
    super(props);

    this.dataModel = new DataModel({
      id: null,
      data: null,
      validationRules: this.props.validationRules,
      validateCallBack: this.validateCallBack,
      type: this.props.type,
    });

    this.state = {
      errorMessage: emptyErrorMessages,
    };
  }

  componentWillUnmount() {
    this.props.clearParentDataModel(this.props.index);
  }

  validateCallBack = ({ errorMessages }) => {
    this.setState({
      errorMessage: errorMessages,
    });
  }

  CollectData = (data) => {
    this.dataModel.id = data.key;
    this.dataModel.data = data;
    this.props.dataCollector({
      index: this.props.index,
      dataModel: this.dataModel,
    });
    this.setState({
      errorMessage: emptyErrorMessages,
    });
  };

  OnFilterOptionsItemDeleted = () => {
    this.props.clearParentDataModel(this.props.index);
    this.props.onFilterOptionsItemDeleted();
  }

  render() {
    const {
      children,
    } = this.props;

    const childProps = {
      CollectData: this.CollectData,
      errorMessage: this.state.errorMessage,
      onFilterOptionsItemDeleted: this.OnFilterOptionsItemDeleted,
      dataModel: this.dataModel,
    };

    return (
      <React.Fragment>
        {renderChildern(children, childProps)}
      </React.Fragment>
    );
  }
}

FilterOptionsGroupItem.propTypes = {
  type: PropTypes.oneOf(types),
  children: PropTypes.node.isRequired,
  index: PropTypes.number,
  dataCollector: PropTypes.func,
  validationRules: PropTypes.arrayOf(PropTypes.shape({
    rule: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.func,
    ]),
    errorMessage: PropTypes.string,
  })),
  onFilterOptionsItemDeleted: PropTypes.func,
  clearParentDataModel: PropTypes.func,
};

FilterOptionsGroupItem.defaultProps = {
  // actually it is passed from parent
  index: 0,
  validationRules: null,
  onFilterOptionsItemDeleted: noop,
  dataCollector: noop,
  clearParentDataModel: noop,
  type: Types.FreeText,
};

export {
  FilterOptionsGroupItem
};
